import React from 'react';
import {Switch} from 'react-router-dom';
import {
  Documents,
  ShareDetails,
  ShareDocument,
} from '../../index';
import {PrivateRoute} from '../../../shared/components/PrivateRoute';

const sections = () => (
  [
    {
      label: 'Documents',
      page: '/documents',
      subsections: [{label: 'Documents', page: '/documents'}],
      content: <Switch>
        <PrivateRoute path='/documents/:id([0-9]+)/share' component={ShareDocument}/>
        <PrivateRoute path='/documents/:id([0-9]+)/sharing' component={ShareDetails}/>
        <PrivateRoute path='/documents' component={Documents}/>
      </Switch>,
    },
  ]
);

export default {sections};
